import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import MyClassesComp from './MyClassesComp'

function MyClasses() {
  return (
    <div className='mainContainer'>
        <LeftmenuIn/>
        <div className='theMainContainer'>
        <DashnavIn/>
        <MyClassesComp/>
        
        </div>
    </div> 
  )
}

export default MyClasses